import {originClick} from '@aboutyou/legacy-tracking-sdk';
import {useTrackOriginClick} from '@aboutyou/tracking';

const useOriginClickTrackingFunction = (originClick: originClick) => {
  const trackOrigin = useTrackOriginClick();
  return trackOrigin(originClick);
};

export const useSimilarProductsPageOriginClick = () => {
  return useOriginClickTrackingFunction('product_reco_page');
};
